var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainPageDiamWithBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 438,
    height: 426,
    viewBox: "0 0 438 426",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 437,
    height: 425,
    rx: 53.5,
    fill: "white",
    stroke: "#D0D7F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainPageDiamWithBorder);
export default __webpack_public_path__ + "static/media/main_page_diam_with_border.77ba4f32a502a6c5c5daa4add82deecc.svg";
export { ForwardRef as ReactComponent };